import { render, staticRenderFns } from "./A2PWizardWebsiteCompliance.vue?vue&type=template&id=6acd5ed0"
import script from "./A2PWizardWebsiteCompliance.vue?vue&type=script&lang=js"
export * from "./A2PWizardWebsiteCompliance.vue?vue&type=script&lang=js"
import style0 from "./a2p-wizard.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports